import './NdcCapabilities.scss';
import {
  Box,
  Tabs,
  Tab,
  List,
  ListItem,
  ListItemText,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { useState, useEffect } from 'react';
import DirectIntegrationTable from '../../../components/DirectIntegrationTable/DirectIntegrationTable';
import DiscoverHeader, { CustomBreadcrumbs } from '../../../components/DiscoverHeader/DiscoverHeader';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import React from 'react';
import TechnologyPartnersTable from '../../../components/TechnologyPartnersTable/TechnologyPartnersTable';
import { useTranslation } from 'react-i18next';
const NdcCapabilities = ({ ...props }) => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  const [activeTabIndex, setActiveTabIndex] = useState<number>(props.showTab);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const header = t('capabilities_header', { returnObjects: true });

  const open = Boolean(anchorEl);

  const tabsLabel = t('capabilities_tabs.tabsLabel', { returnObjects: true });

  const ariaLabel = t('capabilities_tabs.ariaLabel');

  const urls = ['detailed-comparison'];

  const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const title = document.querySelector<HTMLElement>('.discover-header-title');
    if (title) {
      title.style.marginTop = '0px';
    }
  }, []);

  const handleMenuItemClick = (index: number) => {
    setActiveTabIndex(index);
    setAnchorEl(null);
    window.history.pushState(
      null,
      urls[index],
      `/${i18n.language}/ndc-program/ndc-capabilities/${urls[index]}`
    );
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  return (
    <>
      <div className="discover-header">
        <div className="discover-header-left" style={{ marginTop: "15px" }}>

          <CustomBreadcrumbs breadcrumb={header[0].breadcrumbs} />
        </div>
      </div>

      <main>
        <div className="connection-options-container capabilities-container"
          style={{ marginTop: "0px" }}
        >
          <DiscoverHeader
            breadcrumb={header[0].breadcrumbs}
            dropdown={true}
            image="ndcCapabilitiesImage.png"
            paragraph={header[0].subtitle}
            title={header[0].title}
            hideBreadCrumbs={true}
          />
          <div className="connection-options-body-container">
            {isDesktop ? (
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: 'divider',
                  marginX: '26px',
                  marginTop: '10px'
                }}
                className="connectionTabsContainer"
              >
                <Tabs
                  aria-label="Connection Options Tabs"
                  className="connectionTabs"
                  value={activeTabIndex}
                  centered
                  sx={{
                    '& .MuiTab-root.Mui-selected': {
                      color: '#1460AA !important'
                    },
                    '& .MuiTabs-indicator': {
                      backgroundColor: '#1460AA !important'
                    }
                  }}
                >
                  {Array.isArray(tabsLabel) &&
                    tabsLabel.map((label, index) => (
                      <Tab
                        key={`${label}-${index}`}
                        label={label}
                        onClick={() => handleMenuItemClick(index)}
                        value={index}
                        sx={{
                          textTransform: 'none',
                          // fontFamily: 'Open Sans', 
                          fontSize: '14px',
                          fontWeight: 600,
                          ':hover': {
                            color: "#003D78"
                          },
                          '&:focus-visible': {
                            outline: '2px solid black',
                            outlineOffset: '-4px'
                          }
                        }}
                      />
                    ))}
                </Tabs>
              </Box>
            ) : (
              <Box
                className="selectDropdown"
                sx={{
                  maxWidth: '1200px',
                  // width: '100%',
                  marginX: '32px',

                  '@media (max-width: 900px)': {
                    maxWidth: '704px'
                  },
                  px: 0,
                  py: 3,
                  backgroundColor: '#F9F9F9',
                  // ml: '20px'
                }}
              >
                <List
                  aria-label={ariaLabel}
                  component="nav"
                  sx={{
                    width: '96%',
                    position: 'relative',
                    m: 0,
                    p: 0,
                    pl: 0.75,
                    backgroundColor: '#F9F9F9',
                    '&::after': {
                      content: '""',
                      position: 'absolute',
                      bottom: 0,
                      left: '24px', // start border 20px from left
                      right: 0,
                      borderBottom: '1px solid #c9cacc'
                    }
                  }}
                >
                  <ListItem
                    aria-controls="lock-menu"
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="listbox"
                    aria-label={tabsLabel[activeTabIndex]}
                    id="lock-button"
                    onClick={handleClickListItem}
                    sx={{
                      width: '100%',
                      px: 2,
                      py: 1.25,
                      display: 'flex',
                      justifyContent: 'space-between'
                    }}
                  >
                    <ListItemText
                      primary={tabsLabel[activeTabIndex]}
                      primaryTypographyProps={{
                        sx: { fontWeight: 600, fontSize: '14px' }
                      }}
                    />
                    {/* <ListItemText primary={tabsLabel[activeTabIndex]} /> */}
                    <KeyboardArrowDownIcon />
                  </ListItem>
                </List>
                <Menu
                  anchorEl={anchorEl}
                  id="lock-menu"
                  MenuListProps={{
                    'aria-labelledby': 'lock-button',
                    role: 'listbox'
                  }}
                  onClose={handleClose}
                  open={open}
                  slotProps={{
                    paper: {
                      style: {
                        width: anchorEl?.offsetWidth
                      }
                    }
                  }}
                >
                  {Array.isArray(tabsLabel) &&
                    tabsLabel.map((option: string, index: number) => (
                      <MenuItem
                        aria-label={`${tabsLabel[activeTabIndex]}-item`}
                        disabled={index === activeTabIndex}
                        key={option}
                        onClick={() => handleMenuItemClick(index)}
                        role="button"
                        selected={index === activeTabIndex}
                        sx={{ fontWeight: 600 }}
                      >
                        {option}
                      </MenuItem>
                    ))}
                </Menu>
              </Box>
            )}

          {
            [
              <DirectIntegrationTable
                // data={t("capabilities_direct_integration", { returnObjects: true })}
                compPartner={t('capabilities_table_partners', { returnObjects: true })}
              />
            ][activeTabIndex]
          }
        </div>
      </div>
      </main>
    </>
  );
};
export default NdcCapabilities;
